import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { Paper, Typography, Tab, Tabs } from '@material-ui/core'
import { Box } from 'swx-atomic-component-lib'

import EnterpriseManagerDomainsComponent from './enterpriseManager/Domains.component'
import EnterpriseManagerSSOComponent from './enterpriseManager/SingleSignOn.component'
import EnterpriseManagerUsersComponent from './enterpriseManager/Users.component'
import i18n from '../i18n'

const styles = theme => ({
  tabBar: {
    marginBottom: 16
  }
})

class EnterpriseManager extends Component {
  state = {
    selectedTabIndex: 0
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  handleTabChange = (event, selectedTabIndex) => {
    this.setState({ selectedTabIndex })
  }

  render () {
    const { classes } = this.props
    return (
      <Box w='75%' display='flex' flexDirection='column' m='auto'>
        <Typography variant='h5'>{i18n.enterprise.header}</Typography>
        <Paper className={classes.tabBar}>
          <Tabs value={this.state.selectedTabIndex} onChange={this.handleTabChange}>
            <Tab label={i18n.enterprise.domains.tab} />
            <Tab label={i18n.enterprise.users.tab} />
            <Tab label={i18n.enterprise.singleSignOn.tab} />
          </Tabs>
        </Paper>
        {
          this.state.selectedTabIndex === 0 && <EnterpriseManagerDomainsComponent />
        }
        {
          this.state.selectedTabIndex === 1 && <EnterpriseManagerUsersComponent />
        }
        {
          this.state.selectedTabIndex === 2 && <EnterpriseManagerSSOComponent />
        }
      </Box>
    )
  }
}

function mapStateToProps (state) {
  return {
    enterprise: state.enterprise
  }
}

const EnterpriseManagerComponent = withStyles(styles)(EnterpriseManager)

export default connect(mapStateToProps, { /* methods */ })(EnterpriseManagerComponent)
